import apiService from 'src/enviroment';

const serviceLines = {
  getLines: () => apiService.get('/segmentacion/lineas/'),
  postLines: (body) => apiService.post('/segmentacion/lineas/', body),
  putLines: (params) => {
    const body = {
      id: params.newData.id,
      nombre_comercial: params.newData.nombre_comercial.trim(),
    };
    return apiService.put('/segmentacion/lineas/', body);
  },
};

export default serviceLines;
